import { HttpMethod } from "../hooks/useApi";

export const CHANGE_PASSWORD_ENDPOINT = "/users/password";
export const USER_ENDPOINT = "/users";
export const USER_EXISITING_ENDPOINT = "/users/{id}";
export const USER_RESEND_ACTIVATION_MAIL_ENDPOINT = "/users/{id}/activationMail";
export const USER_ACCOUNT_INFORMATIONS_ENDPOINT = "/users/informations";
export const USER_ACCOUNT_ENABLE_ENDPOINT = "/users/enable";
export const NEW_INSCRIPTION_ENFANT_ENDPOINT = "/inscriptions-enfants";
export const INSCRIPTION_ENFANT_ENDPOINT = "/inscriptions-enfants/{id}";
export const INSCRIPTION_ENDPOINT = "/inscriptions";
export const INSCRIPTION_ADULTE_ENDPOINT = "/inscriptions-adultes/{id}";
export const NEW_INSCRIPTION_ADULTE_ENDPOINT = "/inscriptions-adultes";
export const ADHESION_ENDPOINT = "/adhesions/{id}";
export const ADHESION_SEARCH_ENDPOINT = "/adhesions";
export const DELETE_ADHESION_ENDPOINT = "/adhesions";
export const NEW_ADHESION_ENDPOINT = "/adhesions";
export const CHECK_COHERENCE_NEW_INSCRIPTION_ENDPOINT = "/inscriptions-enfants/incoherences";
export const CHECK_COHERENCE_INSCRIPTION_ENDPOINT = "/inscriptions-enfants/{id}/incoherences";
export const NEW_INSCRIPTION_ENFANT_TARIFS_ENDPOINT = "/tarifs-inscription/enfant";
export const INSCRIPTION_ENFANT_EXISTING_TARIFS_ENDPOINT = "/tarifs-inscription/enfant/{id}";
export const NEW_INSCRIPTION_ADULTE_TARIFS_ENDPOINT = "/tarifs-inscription/adulte";
export const INSCRIPTION_ADULTE_EXISTING_TARIFS_ENDPOINT = "/tarifs-inscription/adulte/{id}";
export const TARIFS_ENDPOINT = "/tarifs";
export const TARIFS_ADMIN_ENDPOINT = "/tarifs-admin";
export const TARIFS_ADMIN_GET_ENDPOINT = "/tarifs-admin/{id}";
export const PERIODES_ENDPOINT = "/periodes";
export const PERIODES_EXISTING_ENDPOINT = "/periodes/{id}";
export const PERIODES_VALIDATION_ENDPOINT = "/periodes/validation";
export const PERIODES_EXISTING_VALIDATION_ENDPOINT = "/periodes/{id}/validation";
export const PARAM_REINSCRIPTION_PRIORITAIRE_ENDPOINT = "/params/reinscription-enabled";
export const PARAM_ENDPOINT = "/params";
export const ENSEIGNANT_ENDPOINT = "/enseignants";
export const EXISTING_ENSEIGNANT_ENDPOINT = "/enseignants/{id}";
export const ROLES_ENDPOINT = "/roles";
export const CLASSES_ENDPOINT = "/classes";
export const EXISTING_CLASSES_ENDPOINT = "/classes/{id}";
export const ELEVES_ENDPOINT = "/eleves";
export const ELEVES_ENRICHED_ENDPOINT = "/eleves/enriched";
export const FEUILLE_PRESENCE_ENDPOINT = "/classes/{id}/presences";
export const EXISTING_FEUILLE_PRESENCE_ENDPOINT = "/presences/{id}";
export const BULLETINS_ELEVE_ENDPOINT = "/eleves/{id}/bulletins";
export const BULLETIN_ENDPOINT = "/bulletins";
export const BULLETIN_EXISTING_ENDPOINT = "/bulletins/{id}";
export const MATIERES_ENDPOINT = "/matieres";
export const MES_INSCRIPTIONS_ENDPOINT = "/inscriptions/mes-inscriptions";
export const REINSCRIPTION_ENFANT_ENDPOINT = "/inscriptions-enfants/reinscription";
export const REINSCRIPTION_ADULTE_ENDPOINT = "/inscriptions-adultes/reinscription";
export const RESET_PASSWORD_REQUEST_ENDPOINT = "/users/resetPassword/request";
export const RESET_PASSWORD_INFORMATIONS_ENDPOINT = "/users/resetPassword/informations";
export const RESET_PASSWORD_ENDPOINT = "/users/resetPassword";

export const ERROR_INVALID_CREDENTIALS = "ERROR_INVALID_CREDENTIALS";
export const ERROR_INVALID_OLD_PASSWORD = "ERROR_INVALID_OLD_PASSWORD";

export type ApiCallbacks = {
    [key: string]: (result: any) => void;
}

export const isMatchingEndpoint = (method: string, endpointPattern: string, url: string, httpMethod: string) => {
    // Remplacer les {paramName} par \w+ pour matcher les paramètres dynamiques
    const regex = new RegExp(`^${endpointPattern.replace(/{\w+}/g, "\\w+")}$`);
    // Vérifier si l'URL et la méthode correspondent
    return regex.test(url) && method.toUpperCase() === httpMethod.toUpperCase();
};

export const buildUrlWithParams = (urlTemplate: string, params: Record<string, any>) => {
    return urlTemplate.replace(/\{(\w+)\}/g, (_, key) => params[key] ?? `{${key}}`);
};

export const handleApiCall = (method: HttpMethod, url: string, apiCallbacks: ApiCallbacks) => {
    for (const key in apiCallbacks) {
        const [callbackMethod, endpointPattern] = key.split(":");
        if (isMatchingEndpoint(callbackMethod, endpointPattern, url, method)) {
            return apiCallbacks[key];
        }
    }
    return null;
};